/**
 * Testimonials Slider Component
 * Syncs pagination dots with the horizontally-scrolling testimonials block on mobile.
 */
class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.handleDotClick = this.handleDotClick.bind(this);
  }

  connectedCallback() {
    this.track = this.querySelector('.testimonials-block--mobile-slider');
    this.cards = Array.from(this.querySelectorAll('.testimonial--single-item'));
    this.dots = Array.from(this.querySelectorAll('.testimonials-pagination__dot'));

    if (!this.track || this.cards.length < 2 || this.dots.length !== this.cards.length) return;

    this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = this.cards.indexOf(entry.target);
          if (idx >= 0) this.setActiveDot(idx);
        });
      },
      { root: this.track, threshold: 0.6 }
    );

    this.cards.forEach((card) => this.observer.observe(card));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.dots.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
  }

  handleDotClick(event) {
    const index = parseInt(event.currentTarget.dataset.slideIndex, 10);
    const card = this.cards[index];
    if (!card) return;
    card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  setActiveDot(index) {
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }
}

if (!customElements.get('testimonials-slider')) {
  customElements.define('testimonials-slider', TestimonialsSlider);
}
